// Deprecated. Please refrain from new usage
import PropTypes from "prop-types";
import React from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

import { AppBar, IconButton, Toolbar } from "@material-ui/core";
import { ArrowBack } from "@material-ui/icons";

import Typography from "../Helpers/Typography";

export const WorkflowHeader = ({ headerHeight, history, image, t, title }) => (
  <AppBar>
    <Toolbar
      className="header-bar"
      style={{
        height: headerHeight,
        display: "flex",
        alignItems: "center",
      }}
    >
      {image ? (
        <img src={image} alt="superpedestrian logo" style={{ minHeight: 36, height: "50%" }} />
      ) : (
        <IconButton onClick={history.goBack} edge="start">
          <ArrowBack fontSize="large" />
        </IconButton>
      )}

      {title && (
        <Typography
          style={{
            fontSize: 22,
            fontWeight: 300,
            marginLeft: 10,
          }}
          component="h3"
        >
          {t(title)}
        </Typography>
      )}
    </Toolbar>
  </AppBar>
);

WorkflowHeader.propTypes = {
  headerHeight: PropTypes.number.isRequired,
  history: PropTypes.object.isRequired,
  image: PropTypes.string,
  title: PropTypes.string,
  t: PropTypes.func.isRequired,
};

WorkflowHeader.defaultProps = {
  image: null,
  title: null,
};

export default withTranslation("common")(withRouter(WorkflowHeader));
